@if (loading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
}

<div style="padding-bottom: 10px;text-align: right;" class="event-section">
  <button mat-menu-item [routerLink]="['/private/Tracking/UpsertEvent/'+ -1]">
    <mat-icon>add</mat-icon>
  </button>
</div>

<table mat-table [dataSource]="events" class="mat-elevation-z8 full-width">

  <!-- Event Name -->
  <ng-container matColumnDef="event">
    <th mat-header-cell *matHeaderCellDef> Event </th>
    <td mat-cell *matCellDef="let event">
      <strong matTooltip="{{ event.FriendlyName }}">{{ event.Name }}</strong><br/>
      <span>{{event.Remark}}</span>
    </td>
  </ng-container>

  <!-- Producers -->
  <ng-container matColumnDef="producers">
    <th mat-header-cell *matHeaderCellDef> Producers </th>
    <td mat-cell *matCellDef="let event">
      @if (event.Producers.length > 0) {
          <div class="event-section">
            <ul>
              @for (producer of event.Producers; track producer) {
                <li>
                  {{ producer.FriendlyName || producer.Name }}
                </li>
              }
            </ul>
          </div>
        }
         @if (event.Producers.length === 0 && event.Consumers.length === 0) {
          <div class="event-section empty">
            <em>No producers or consumers.</em>
          </div>
        }
    </td>
  </ng-container>

  <!-- Consumers -->
  <ng-container matColumnDef="consumers">
    <th mat-header-cell *matHeaderCellDef> Consumers </th>
    <td mat-cell *matCellDef="let event">
      @if (event.Consumers.length > 0) {
          <div class="event-section">
            <ul>
              @for (consumer of event.Consumers; track consumer) {
                <li>
                  {{ consumer.FriendlyName || consumer.Name }}
                </li>
              }
            </ul>
          </div>
        }
         @if (event.Producers.length === 0 && event.Consumers.length === 0) {
          <div class="event-section empty">
            <em>No producers or consumers.</em>
          </div>
        }
    </td>
  </ng-container>

  <!-- Update -->
  <ng-container matColumnDef="update">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let event">
          <div style="padding-bottom: 20px;" class="event-section">
            <button mat-menu-item [routerLink]="['/private/Tracking/UpsertEvent/'+ event.Id]">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
    </td>
  </ng-container>

  <!-- Header & Rows -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>